import {types} from './types';

const setGetHistoryListAction = (payload) => {
    return {
        type: types.SET_HISTORY_LIST,
        payload,
      }
}

export {
  setGetHistoryListAction
}